import React, { useEffect} from "react";
import styled from 'styled-components';
import theme from '../../../styles/theme';

const MainWrap =  styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: ${theme.color.black[60]};
    z-index: 1200;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const MainBody = styled.div`
    width: calc(40% - 32px);
    // height: calc(40% - 32px);
    max-width: calc(40% - 32px);
    // min-height: calc(50% - 32px);
    background: ${theme.color.white[100]};
    border-radius: 16px;
    padding: 16px;
`;

const MsgModal = (props) => {

    function logic(e) {
        if(e && e.keyCode === 27 &&
            props.open===true  && props.children && props.children.props && props.children.props.onClick){
            props.children.props.onClick()
        }
    }

    useEffect(() => {
        function keydown() {
          window.addEventListener("keydown", logic);
        }
        keydown();
        return () => {
          window.removeEventListener("scroll", logic);
        };
      });

    return props.open===true && props.children ? (
        <MainWrap>
            <MainBody>
                {props.children}
            </MainBody>
        </MainWrap>
    )
    : <React.Fragment />

}

export default MsgModal;